/**
 * Created by slava on 24.03.17.
 */

const SettingsWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        const user = this.createUser();

        const buttons = [];

        if (!cleverapps.flags.nologin && !connector.social.isLoggedIn()) {
            buttons.push(this.addSaveProgressButton());
        }

        if (!cleverapps.flags.nologin && connector.social.isLoggedIn() && connector.platform.oneOf(connector.TEST)) {
            buttons.push(this.addLogoutButton());
        }

        if (cleverapps.config.languages.length > 1 && !connector.platform.oneOf(connector.YANDEX) && (["merge", "merge2"].includes(cleverapps.config.type) || !cleverapps.environment.isGameScene())) {
            buttons.push(this.addLanguages());
        }

        if ((["merge", "merge2", "blocks"].includes(cleverapps.config.type) || !Game.currentGame) && Chat.IsAvailable()) {
            buttons.push(this.addSupportButton());
        }

        if (cleverapps.crossPromo && cleverapps.crossPromo.havePromotion()) {
            buttons.push(this.addCrossPromoButton());
        }

        if (typeof Game !== "undefined" && Game.currentGame && Game.currentGame.outcome === undefined && cleverapps.environment.isGameScene() && cleverapps.lives && levels.user.checkAvailable(cleverapps.config.availables.GIVE_UP_BUTTON)) {
            buttons.push(this.addGiveUpButton());
        }

        const styles = cleverapps.styles.SettingsWindow;
        const isVertical = cleverapps.resolution.isVertical();

        const buttonsLayout = this.buttonsLayout = new cleverapps.GridLayout(buttons, {
            columns: isVertical ? 1 : 2,
            margin: styles.grid.margin
        });

        const controlButtons = this.createControlButtonsLayout();

        const content = new cleverapps.Layout([user, buttonsLayout, controlButtons, this.createFooter()].filter(Boolean), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: styles.padding
        });

        if (connector.info.isMobile && styles.mobile && styles.mobile.scale) {
            content.setScale(styles.mobile.scale[cleverapps.resolution.mode]);
        }

        this._super({
            title: Messages.get("SettingsWindow.title"),
            name: "settingswindow",
            content,
            contentPadding: styles.contentPadding
        });

        this.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 3);
        this.adjustButtons();

        const cheapProductNode = new cc.Node();
        cheapProductNode.setContentSize(styles.cheapProduct);
        cheapProductNode.setAlignment(styles.cheapProduct);
        content.addChild(cheapProductNode);

        cleverapps.UI.onClick(cheapProductNode, () => {
            console.log("cheap product click");
        }, {
            onDoubleClick: function () {
                const cheapProduct = Product.CreateById("cheapProduct");

                if (!cheapProduct) {
                    cleverapps.notification.create(`СheapProduct not found, payments - ${connector.payments.getName()}`);
                    return;
                }
                cheapProduct.buy((code) => {
                    if (code === connector.CODE_SUCCEED) {
                        this.close();
                    }
                });
            }.bind(this)
        });

        const sendNotificationNode = new cc.Node();
        sendNotificationNode.setContentSize(styles.sendNotification);
        sendNotificationNode.setAlignment(styles.sendNotification);
        content.addChild(sendNotificationNode);

        cleverapps.UI.onClick(sendNotificationNode, () => {
            console.log("send notification click");
        }, {
            onDoubleClick: function () {
                connector.notifications.askPermission(() => {
                    if (!connector.notifications.isPermitted()) {
                        cleverapps.notification.create("Notifications are not permitted");
                        return;
                    }
                    PushHelper.sendPush(PUSHES.WELCOME, cleverapps.parseInterval("5 minutes"));
                    cleverapps.notification.create("Test notification scheduled in 5 minutes");
                });
            }
        });

        cleverapps.settings.on("changedAvatar", () => this.createAvatar(), this);
        cleverapps.settings.on("changedNickname", () => this.createInfo(), this);
    },

    getLoadingTasks: function () {
        return [(onSuccess) => {
            cleverapps.UI.Avatar.preload(cleverapps.settings.getAvatar(), cleverapps.waitNoMore(300, onSuccess));
        }];
    },

    getPerson: function () {
        return cleverapps.styles.SettingsWindow.person;
    },

    createUser: function () {
        const styles = cleverapps.styles.SettingsWindow;

        const background = this.userContent = cleverapps.UI.createScale9Sprite(bundles.settings_window.frames.user_info_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize2(
            styles.user.size[cleverapps.resolution.mode].width,
            styles.user.size[cleverapps.resolution.mode].height || background.getSpriteFrame().getOriginalSize().height
        );

        this.createAvatar();
        this.createInfo();

        if (connector.platform.listShareChannels().length > 0) {
            const invite = new InviteButton({
                width: styles.invite.width,
                height: styles.invite.height,
                type: cleverapps.styles.UI.Button.Images.small_button_green,
                content: new cc.Sprite(bundles.settings_window.frames.invite_icon),
                onSuccess: this.closeWindow.bind(this)
            });

            invite.setAlignment(styles.invite.position);
            background.addChild(invite);
        }

        return cleverapps.UI.wrapWithPadding(background, styles.user.padding);
    },

    createAvatar: function () {
        if (this.avatar) {
            this.avatar.removeFromParent();
        }

        const styles = cleverapps.styles.SettingsWindow.avatar;

        const player = { ...connector.player, ...{ avatar: cleverapps.settings.getAvatar() } };

        let position = styles.position;

        if (cleverapps.UI.Avatar.IsExternal(player.avatar)) {
            position = styles.externalPosition || position;
            this.avatar = new cleverapps.UI.Avatar(player, {
                useFrame: false,
                padding: styles.externalPadding,
                size: styles.externalSize,
                rounded: true,
                foreground: bundles.settings_window.frames.avatar_foreground
            });
        } else if (bundles.avatars.frames.default_avatar_big) {
            this.avatar = new cleverapps.UI.Avatar(player, {
                useBigImage: true,
                useFrame: false,
                padding: styles.padding,
                size: styles.size
            });
        } else {
            this.avatar = new cleverapps.UI.Avatar(player, {
                defaultImage: bundles.settings_window.frames.avatar_default,
                frame: bundles.settings_window.frames.avatar_frame,
                padding: styles.padding
            });
        }

        this.avatar.setAlignment(position);
        this.userContent.addChild(this.avatar);

        if (typeof ProfileWindow !== "undefined" && ProfileWindow.IsSelectionAvailable()) {
            cleverapps.UI.onClick(this.avatar, () => {
                cleverapps.focusManager.display({
                    focus: "ProfileWindow",
                    stack: true,
                    action: (f) => {
                        new ProfileWindow();
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            });
        }
    },

    createInfo: function () {
        if (this.infoLayout) {
            this.infoLayout.removeFromParent();
        }

        const styles = cleverapps.styles.SettingsWindow.info;

        const rows = [this.createNameRow(), this.createIdRow()];

        rows.forEach((row) => row.setAnchorPoint(0, 0.5));

        this.infoLayout = new cleverapps.Layout(rows, {
            direction: cleverapps.UI.VERTICAL,
            margin: rows.length > 2 ? styles.smallMargin : styles.margin
        });

        this.infoLayout.setAlignment(styles.position);
        this.userContent.addChild(this.infoLayout);
    },

    createNameRow: function () {
        const styles = cleverapps.styles.SettingsWindow.text;

        this.nickname = cleverapps.UI.generateOnlyText(cleverapps.settings.getNickname(), cleverapps.styles.FONTS.SETTINGS_WINDOW_NAME_TEXT);
        this.nickname.setHorizontalAlignment(cc.TEXT_ALIGNMENT_LEFT);
        if (styles.size) {
            this.nickname.fitTo(styles.size[cleverapps.resolution.mode].width);
        }

        if (typeof ProfileWindow !== "undefined" && ProfileWindow.IsSelectionAvailable()) {
            const editProfileButton = new cc.Sprite(bundles.settings_window.frames.edit_profile_icon);
            cleverapps.UI.onClick(editProfileButton, () => {
                cleverapps.focusManager.display({
                    focus: "ProfileWindow",
                    stack: true,
                    action: (f) => {
                        new ProfileWindow();
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            });

            return new cleverapps.Layout([this.nickname, editProfileButton], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.margin
            });
        }

        return this.nickname;
    },

    createIdRow: function () {
        const styles = cleverapps.styles.SettingsWindow.text;

        const idText = cleverapps.UI.generateOnlyText(`ID: ${connector.player.id}`, cleverapps.styles.FONTS.SETTINGS_WINDOW_ID_TEXT);
        idText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_LEFT);
        if (styles.size) {
            idText.fitTo(styles.size[cleverapps.resolution.mode].width);
        }
        idText.setOpacity(cleverapps.styles.SettingsWindow.textOpacity);

        let copyId;
        if (!cleverapps.flags.norest || cleverapps.config.debugMode) {
            copyId = new cc.Sprite(bundles.settings_window.frames.copyid_icon);
        }

        const idRow = new cleverapps.Layout([idText, copyId].filter(Boolean), {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });

        if (copyId) {
            const callback = function () {
                cleverapps.copyToClipboard(connector.platform.getUserID(), () => {
                    cleverapps.notification.create(Messages.get("SettingsWindow.UserID.copied"));
                });
            };

            cleverapps.UI.onClick(idRow, callback, { interactiveScale: false });
            cleverapps.UI.onClick(copyId, callback, { hover: true });
        }

        return idRow;
    },

    createPromoTrackerInfo: function () {
        if (!cleverapps.rewardedPromoTracker || !cleverapps.rewardedPromoTracker.isActive()) {
            return undefined;
        }

        const styles = cleverapps.styles.SettingsWindow.promoText;

        const promotion = cleverapps.rewardedPromoTracker.promotion;
        const name = promotion.getSourceName();

        const projectText = cleverapps.UI.generateOnlyText(Messages.get("RewardedPromoTracker.link", { name }), cleverapps.styles.FONTS.SETTINGS_WINDOW_VERSION_TEXT);
        projectText.fitTo(styles.size[cleverapps.resolution.mode].width);
        projectText.setOpacity(cleverapps.styles.SettingsWindow.textOpacity);

        const link = new cc.Node();
        link.setAnchorPoint(0.5, 0.5);
        link.setContentSize2(projectText.getContentSize());
        projectText.setPosition(link.width / 2, link.height / 2);
        link.addChild(projectText);

        if (connector.platform.canSwitchGame()) {
            link.addChild(cleverapps.UI.drawUnderline(projectText, {
                x: projectText.x,
                y: projectText.y - projectText.height / 2 + styles.underlineDy
            }));

            cleverapps.UI.onClick(link, () => {
                const crossPromo = cleverapps.crossPromo.createPromotion(promotion.sourceId);
                connector.platform.switchGame(crossPromo && crossPromo.link);
            });
        }

        return link;
    },

    createFooter: function () {
        const rows = [this.createVersion(), this.createPromoTrackerInfo()].filter(Boolean);
        if (rows.length === 1) {
            return rows[0];
        }

        return new cleverapps.Layout(rows, {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.SettingsWindow.promoText.margin
        });
    },

    addGiveUpButton: function () {
        const styles = cleverapps.styles.SettingsWindow;

        return new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_red,
            content: this.createTextWithIcon("GiveUp", bundles.settings_window.frames.giveup_icon),
            onClicked: () => {
                this.close();

                cleverapps.focusManager.whenFreeFocus(() => {
                    const scene = cleverapps.Scenes.GetRunningScene();
                    scene.sceneComponent.closeAction();
                });
            },
            width: styles.button.width,
            height: styles.button.height
        });
    },

    addSupportButton: function () {
        const styles = cleverapps.styles.SettingsWindow;

        return new cleverapps.UI.Button({
            content: this.createTextWithIcon("SupportButton", bundles.settings_window.frames.support_icon),
            onClicked: () => {
                this.close();

                cleverapps.focusManager.distract({
                    focus: "ChatScene",
                    action: (f) => {
                        cleverapps.meta.switchLocation(cleverapps.meta.getMainLocationId());
                        cleverapps.scenes.replaceScene(Prefab.instantiate(bundles.main.jsons.chatscene_prefab_json, { args: [cleverapps.chat] }), f);
                    }
                });
            },
            width: styles.button.width,
            height: styles.button.height,
            mark: cleverapps.chat.hasUnread
        });
    },

    addLanguages: function () {
        const styles = cleverapps.styles.SettingsWindow;

        return new cleverapps.UI.Button({
            content: this.createTextWithIcon("Language", bundles.settings_window.frames.language_icon),
            onClicked: () => {
                this.close();

                cleverapps.focusManager.display({
                    focus: "LanguagesWindow",
                    stack: true,
                    action: (f) => {
                        new LanguagesWindow();
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            },
            width: styles.button.width,
            height: styles.button.height,
            click_effect: undefined
        });
    },

    createLine: function () {
        const styles = cleverapps.styles.SettingsWindow;

        const line = cleverapps.UI.createScale9Sprite(bundles.settings_window.frames.line, cleverapps.UI.Scale9Rect.TwoPixelXY);
        line.setContentSize2(styles.line.size[cleverapps.resolution.mode]);

        return cleverapps.UI.wrapWithPadding(line, styles.line.padding[cleverapps.resolution.mode]);
    },

    createControlButtonsLayout: function () {
        const isVertical = cleverapps.resolution.isVertical();
        const styles = cleverapps.styles.SettingsWindow;

        let followUs = this.createFollowUs();
        let controlButtons = this.createControlButtons();

        if (!followUs && !controlButtons) {
            return;
        }

        const createEmptyGridNode = function () {
            const node = new cc.Node();
            node.setContentSize(styles.button.width, (followUs || controlButtons).height);
            return node;
        };

        if (!isVertical) {
            followUs = followUs || createEmptyGridNode();
            controlButtons = controlButtons || createEmptyGridNode();
        }

        const grid = new cleverapps.GridLayout([followUs, isVertical && this.createLine(), controlButtons].filter(Boolean), {
            columns: isVertical ? 1 : 2,
            margin: styles.grid.margin
        });

        const layout = new cleverapps.Layout([!isVertical && this.createLine(), grid].filter(Boolean), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        return layout;
    },

    createControlButtons: function () {
        let data = [];

        if (connector.platform.oneOf(
            connector.TEST,
            connector.ANDROID,
            connector.IOS,
            connector.WECHAT,
            connector.INSTANT,
            connector.DISCORD,
            connector.CRAZY,
            connector.SAMSUNG,
            connector.G5WINDOWS
        )) {
            data.push({
                type: cleverapps.styles.UI.Button.Images.settings_control_button,
                content: new cc.Sprite(bundles.settings_window.frames.info_icon),
                onClicked: () => {
                    cleverapps.focusManager.display({
                        focus: "AboutWindow",
                        stack: true,
                        action: (f) => {
                            new AboutWindow();
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }
                    });
                }
            });
        }

        if (!connector.platform.hasAudioControls) {
            data = data.concat([
                {
                    type: cleverapps.styles.UI.Button.Images.settings_control_button,
                    content: new cc.Sprite(bundles.settings_window.frames.sound_on_png),
                    contentOff: new cc.Sprite(bundles.settings_window.frames.sound_off_png),
                    toggle: cleverapps.settings.toggleSound.bind(cleverapps.settings),
                    settings: "sound",
                    listener: "onChangeSoundListener"
                },
                {
                    type: cleverapps.styles.UI.Button.Images.settings_control_button,
                    content: new cc.Sprite(bundles.settings_window.frames.music_on_png),
                    contentOff: new cc.Sprite(bundles.settings_window.frames.music_off_png),
                    toggle: cleverapps.settings.toggleMusic.bind(cleverapps.settings),
                    settings: "music",
                    listener: "onChangeMusicListener"
                }
            ]);
        }

        if (cleverapps.config.vibration && (connector.platform.hasVibration() || cleverapps.config.debugMode)) {
            data.push({
                type: cleverapps.styles.UI.Button.Images.settings_control_button,
                content: new cc.Sprite(bundles.settings_window.frames.vibro_on_png),
                contentOff: new cc.Sprite(bundles.settings_window.frames.vibro_off_png),
                toggle: cleverapps.settings.toggleVibration.bind(cleverapps.settings),
                settings: "vibrate",
                listener: "onChangeVibrationListener"
            });
        }

        if (SettingsWindow.IsExitButtonAvailable() && cleverapps.environment.isMainScene()) {
            data.push({
                type: cleverapps.styles.UI.Button.Images.settings_control_red_button,
                content: new cc.Sprite(bundles.settings_window.frames.exit_icon),
                onClicked: () => {
                    this.close();

                    cleverapps.focusManager.distract({
                        focus: "ConfirmExitWindow",
                        action: (f) => {
                            new ConfirmExitWindow({
                                spine: bundles.confirmexit_window.jsons.app_confirmexit_window_json,
                                source: ConfirmExitWindow.SOURCES.EXIT_APP,
                                action: () => {
                                    connector.platform.closeApplication();
                                }
                            });

                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }
                    });
                }
            });
        }

        if (data.length === 0) {
            return;
        }

        const styles = cleverapps.styles.SettingsWindow;

        const buttons = data.map((data) => {
            const button = new cleverapps.UI.Button({
                type: data.type,
                content: data.content,
                contentOff: data.contentOff,
                width: styles.controlButton.width,
                height: styles.controlButton.height,
                onClicked: data.onClicked || data.toggle
            });

            if (data.settings) {
                button.setBright(cleverapps.settings[data.settings]);
                cleverapps.settings[data.listener] = button.createListener(() => {
                    button.setBright(cleverapps.settings[data.settings]);
                });
            }

            return button;
        });

        const layout = new cleverapps.Layout(buttons, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.controlButton.margin
        });

        const padding = cleverapps.resolution.isVertical()
            ? { x: Math.max(0, (styles.button.width - layout.width) / 2) }
            : { left: Math.max(0, (styles.button.width - layout.width)) };

        return cleverapps.UI.wrapWithPadding(layout, padding);
    },

    addSaveProgressButton: function () {
        const styles = cleverapps.styles.SettingsWindow;
        const sources = connector.social.listAvailable();

        if (connector.info.isNative || connector.platform.oneOf(connector.YANDEX) || sources.length > 1) {
            return new cleverapps.UI.Button({
                content: this.createTextWithIcon("SettingsWindow.SaveProgressButton", bundles.settings_window.frames.save_progress_icon),
                onClicked: () => {
                    this.close();

                    cleverapps.focusManager.display({
                        focus: "SignInWindow",
                        stack: true,
                        action: (f) => {
                            new SignInWindow();
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }
                    });
                },
                width: styles.button.width,
                height: styles.button.height,
                click_effect: undefined
            });
        }

        const icon = LoginButton.getIcon(connector.info.source) || bundles.settings_window.frames.save_progress_icon;

        return new LoginButton({
            width: styles.button.width,
            height: styles.button.height,
            content: this.createTextWithIcon("SettingsWindow.SaveProgressButton", icon),
            onSuccess: this.closeWindow.bind(this)
        });
    },

    addLogoutButton: function () {
        const styles = cleverapps.styles.SettingsWindow;

        return new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            content: this.createTextWithIcon("SettingsWindow.Logout", bundles.settings_window.frames.save_progress_icon),
            onClicked: function () {
                connector.social.logout();
                this.closeWindow();
            }.bind(this)
        });
    },

    createFollowUs: function () {
        if (connector.platform.oneOf(
            connector.MOBAGE,
            connector.SP_MOBAGE,
            connector.GDCOM,
            connector.COOLMATHGAMES,
            connector.PLINGA,
            connector.AMAZON,
            connector.DIGITAL,
            connector.DIGITALWEB,
            connector.RUSTORE,
            connector.LABSYSTECH,
            connector.YANDEX,
            connector.MICROSOFT,
            connector.MYGAMES,
            connector.WECHAT,
            connector.YOUTUBE,
            connector.GAMESNACK,
            connector.SAMSUNG,
            connector.REDDIT,
            connector.G5WINDOWS,
            connector.MSIX,
            connector.ARKADIUM
        )) {
            return;
        }

        const styles = cleverapps.styles.SettingsWindow;
        const isVertical = cleverapps.resolution.isVertical();

        const text = cleverapps.UI.generateOnlyText(Messages.get("SettingsWindow.FollowUs"), cleverapps.styles.FONTS.SETTINGS_WINDOW_FOLLOW_US_TEXT);
        text.setOpacity(cleverapps.styles.SettingsWindow.textOpacity);

        const icon = bundles.group_icons.frames[`${connector.info.source}_icon`] || bundles.group_icons.frames.facebook_icon;
        const sprite = new cc.Sprite(icon);

        cleverapps.UI.onClick(sprite, () => {
            connector.social.joinCommunityCallback();
        }, { hover: true });

        const layout = new cleverapps.Layout([text, isVertical && this.createLine(), sprite].filter(Boolean), {
            direction: isVertical ? cleverapps.UI.VERTICAL : cleverapps.UI.HORIZONTAL,
            margin: styles.followUs.margin,
            reversed: cleverapps.UI.isRTL() && !isVertical
        });

        const padding = isVertical
            ? { x: Math.max(0, (styles.button.width - layout.width) / 2) }
            : { right: Math.max(0, (styles.button.width - layout.width)) };

        return cleverapps.UI.wrapWithPadding(layout, padding);
    },

    createVersion: function () {
        const text = cleverapps.UI.generateOnlyText(`v${cleverapps.config.version}`, cleverapps.styles.FONTS.SETTINGS_WINDOW_VERSION_TEXT);
        text.fitTo(cleverapps.styles.SettingsWindow.button.width);
        text.setOpacity(cleverapps.styles.SettingsWindow.textOpacity);
        return text;
    },

    addCrossPromoButton: function () {
        const styles = cleverapps.styles.SettingsWindow.button;

        return new cleverapps.UI.Button({
            content: this.createTextWithIcon("CrossPromo.title", bundles.settings_window.frames.more_games_icon),
            onClicked: () => {
                this.close();

                cleverapps.CrossPromo.OpenCrossPromoWindow();
            },
            width: styles.width,
            height: styles.height,
            mark: cleverapps.crossPromo && cleverapps.crossPromo.hasMark(),
            click_effect: undefined
        });
    },

    createTextWithIcon: function (text, icon) {
        const styles = cleverapps.styles.SettingsWindow.button;

        icon = new cc.Sprite(icon);

        const iconWrapper = cleverapps.UI.wrapWithPadding(icon);
        iconWrapper.width = styles.icon.width;
        icon.x = iconWrapper.width / 2;

        text = cleverapps.UI.generateOnlyText(Messages.get(text), cleverapps.styles.FONTS.SETTINGS_BUTTON_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        const textWrapper = cleverapps.UI.wrapWithPadding(text);
        textWrapper.width = styles.text.width;
        textWrapper.height = styles.text.height;
        text.x = textWrapper.width / 2;
        text.y = textWrapper.height / 2;
        text.fitTo(textWrapper.width);

        const layout = new cleverapps.Layout([iconWrapper, textWrapper], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin,
            padding: styles.padding
        });

        layout.text = text;
        layout.icon = icon;

        return layout;
    },

    adjustButtons: function () {
        let fontSize = cleverapps.styles.FONTS.SETTINGS_BUTTON_TEXT.size;
        const buttons = this.buttonsLayout.children;
        let i;

        for (i = 0; i < buttons.length; i++) {
            fontSize = Math.min(fontSize, buttons[i].content.text.getFontSize());
        }

        for (i = 0; i < buttons.length; i++) {
            buttons[i].content.text.setFontSize(fontSize);
        }
    },

    closeWindow: function () {
        if (!this.closed) {
            this.close();
        }
    },

    listBundles: function () {
        const bundles = ["settings_window"];
        if (cleverapps.rewardedPromoTracker && cleverapps.rewardedPromoTracker.isActive()) {
            bundles.push("crosspromo");
        }
        return bundles;
    }
});

SettingsWindow.IsExitButtonAvailable = function () {
    return [cc.sys.OS_ANDROID].indexOf(connector.info.os) !== -1 && connector.info.isNative && connector.platform.hasCloseApplication();
};

cleverapps.styles.COLORS = cleverapps.overrideColors(cleverapps.styles.COLORS, {
    SETTINGS_WINDOW_TEXT_COLOR: new cc.Color(161, 80, 37, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SETTINGS_WINDOW_NAME_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    },

    SETTINGS_WINDOW_ID_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    },

    SETTINGS_WINDOW_FOLLOW_US_TEXT: {
        name: "nostroke",
        size: 33,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    },

    SETTINGS_WINDOW_VERSION_TEXT: {
        name: "nostroke",
        size: 25,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    },

    SETTINGS_BUTTON_TEXT: {
        size: 63,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    }
});

cleverapps.overrideTemplates(cleverapps.styles.UI.Button.Images, {
    settings_control_button: {
        button_png: bundles.buttons.frames.button_png,
        button_on_png: bundles.buttons.frames.button_on_png,
        button_off_png: bundles.buttons.frames.button_disabled_png,
        SKIP_RESOLUTION: {
            padding: {
                left: 0.05,
                right: 0.05,
                top: 0.05,
                bottom: 0.05
            }
        }
    },

    settings_control_red_button: {
        button_png: bundles.buttons.frames.red_button,
        button_on_png: bundles.buttons.frames.red_button_on,
        button_off_png: bundles.buttons.frames.button_disabled_png,
        SKIP_RESOLUTION: {
            padding: {
                left: 0.05,
                right: 0.05,
                top: 0.05,
                bottom: 0.05
            }
        }
    }
});

cleverapps.styles.SettingsWindow = {
    margin: 20,
    textOpacity: 128,
    padding: {},

    mobile: {
        scale: [1, 1.2, 1.2]
    },

    user: {
        size: [{
            width: 680,
            height: 200
        }, {
            width: 1200,
            height: 200
        }, {
            width: 1200,
            height: 200
        }],

        padding: {
            y: 10
        }
    },

    text: {
        size: [{ width: 280 }, { width: 800 }, { width: 800 }],
        margin: 10
    },

    promoText: {
        size: [{ width: 400 }, { width: 860 }, { width: 860 }],
        margin: 8,
        underlineDy: -4
    },

    info: {
        margin: 30,
        smallMargin: 14,

        position: [{
            x: { align: "left", dx: 194 },
            y: { align: "center" }
        }, {
            x: { align: "left", dx: 220 },
            y: { align: "center" }
        }, {
            x: { align: "left", dx: 220 },
            y: { align: "center" }
        }]
    },

    avatar: {
        position: {
            x: { align: "left" },
            y: { align: "center" }
        },

        externalPosition: {
            x: { align: "left", dx: 30 },
            y: { align: "center" }
        },

        padding: {
            x: 18,
            top: 18,
            bottom: 18
        },

        externalSize: {
            width: 160,
            height: 160
        },

        externalPadding: 0
    },

    invite: {
        position: [{
            x: { align: "right", dx: -15 },
            y: { align: "top", dy: -15 }
        }, {
            x: { align: "right", dx: -30 },
            y: { align: "top", dy: -15 }
        }, {
            x: { align: "right", dx: -30 },
            y: { align: "top", dy: -15 }
        }],

        width: 115,
        height: 80
    },

    grid: {
        margin: {
            x: 50,
            y: 18
        }
    },

    button: {
        width: 580,
        height: 125,

        text: {
            width: 430,
            height: 90
        },

        icon: {
            width: 60
        },

        margin: 10,

        padding: {
            right: 0
        }
    },

    controlButton: {
        margin: 10,

        width: 112,
        height: 110
    },

    cheapProduct: {
        x: { align: "right", dx: 60 },
        y: { align: "bottom", dy: -60 },
        width: 120,
        height: 120
    },

    sendNotification: {
        x: { align: "left", dx: -60 },
        y: { align: "bottom", dy: -60 },
        width: 120,
        height: 120
    },

    line: {
        size: [{
            width: 570,
            height: 5
        }, {
            width: 1200,
            height: 5
        }, {
            width: 1200,
            height: 5
        }],

        padding: [
            { top: 0, bottom: 10 },
            { top: 10, bottom: 6 },
            { top: 10, bottom: 6 }
        ]
    },

    followUs: {
        margin: 20
    }
};
